<div class="not-found-container">
  <app-navbar></app-navbar>
  <div class="content">
    <h1 class="title">Page Not Found</h1>
    <p class="subtitle">The page you’re looking for doesn’t exist or has been moved.</p>
    <a routerLink="/scheduler" class="home-link">Go back to the home page</a>
  </div>
  <app-footer></app-footer>
</div>


